import React, { useContext, createRef, useState } from 'react';
import { store } from './reducer';
import { DataGrid } from '../../../../../../components/DataGrid/DataGrid';
import moment from 'moment-jalaali';
import { localText } from '../../../../../../langs/fa/data-grid';
import formatNumber from '../../../../../../fns/formatNumber';
import Avatar from '../../../../../../components/User/UserAvatar';
import { useHistory } from 'react-router-dom';
import useRules from 'hooks/useRules';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from '../../../../../../api/axios';
import useToast from 'hooks/useToast';
import CircularProgress from '@material-ui/core/CircularProgress';
import { baseURL } from 'config';
import { store as mainStore } from '../../../../../../store';
import { isMobile } from 'react-device-detect';

const ref = createRef();

const List = () => {
  const history = useHistory();
  const [rules, hasRule, isAdmin] = useRules();
  const {
    state: {
      Auth: { profile },
    },
  } = useContext(mainStore);
  const toast = useToast();
  const {
    state: {
      progress,
      reports,
      page,
      startDate,
      endDate,
      customers,
      drivers,
      operators,
      user,
      totalCommission,
    },
    dispatch,
    itemsCountPerPage,
  } = useContext(store);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      field: 'rowNumber',
      headerName: 'ردیف',
      width: 100,
    },
    {
      field: 'loadingDate',
      headerName: 'تاریخ',
      width: 100,
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 100,
    },
    {
      field: 'waybillType',
      headerName: 'نوع بارنامه',
      width: 120,
    },
    // {
    //   field: 'commissions',
    //   headerName: 'کارمزد شرکت',
    //   flex: 1,
    // },
    // {
    //   field: 'tracingCode',
    //   headerName: 'کد رهگیری',
    //   width: 150,
    // },
    {
      field: 'owner',
      headerName: ' صاحب بار',
      flex: 1,
    },
    {
      field: 'commissionDeposit',
      headerName: 'کارمزد متعلقه',
      flex: 1,
    },
    // {
    //   field: 'transactionDate',
    //   headerName: 'تاریخ واریز',
    //   width: 150,
    // },
    {
      field: 'status',
      headerName: 'وضعیت',
      width: 180,
    },
  ];
  const columnAdmin = [
    {
      field: 'rowNumber',
      headerName: 'ردیف',
      width: 100,
    },
    {
      field: 'user',
      headerName: 'کاربر',
      flex: 1,
      renderCell: ({ value }) => (
        <>
          {value?._id ? (
            <Avatar user={value} fullName width={30} height={30} />
          ) : null}
        </>
      ),
    },
    {
      field: 'loadingDate',
      headerName: 'تاریخ',
      width: 100,
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 150,
    },
    {
      field: 'waybillType',
      headerName: 'نوع بارنامه',
      width: 120,
    },
    {
      field: 'commissions',
      headerName: 'کارمزد شرکت',
      flex: 1,
    },
    // {
    //   field: 'tracingCode',
    //   headerName: 'کد رهگیری',
    //   width: 150,
    // },
    {
      field: 'owner',
      headerName: ' صاحب بار',
      flex: 1,
    },
    {
      field: 'commissionDeposit',
      headerName: 'کارمزد متعلقه',
      flex: 1,
    },
    // {
    //   field: 'transactionDate',
    //   headerName: 'تاریخ واریز',
    //   width: 150,
    // },
    {
      field: 'status',
      headerName: 'وضعیت',
      width: 180,
    },
  ];
  const _waybillType = {
    custom: 'سفارشی',
    police: 'پلیس راهی',
    software: 'کامل',
  };
  const getStatus = (status) => {
    let s = '';
    if (status) {
      s = 'قابل برداشت';
    } else if (!status) s = 'در انتظار تخلیه';
    else s = '';
    return s;
  };
  const handlePageChange = ({ page }) => {
    dispatch({ type: 'CHANGE_PAGE', payload: page });
  };
  const handleSelectRow = (selection) => {
    let orderId = reports?.docs?.filter((x) => x._id == selection.row.id)[0];

    orderId = orderId.log?.order._id;

    history.push(`/protected/admin/orders/${orderId}`);
  };
  const handleDownloadExcel = async () => {
    try {
      //loading
      toast.success('لطفا منتظر بمانید!');

      setLoading(true);
      const response = await axios.get(
        `/api/v1/admin/reports/commissionDepositsForDateResult?customers=${customers}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}&drivers=${drivers}&limit=2000&operators=${operators}&user=${
          hasRule('can_manage_operators') || isAdmin
            ? user?.[0]?._id
            : profile._id
        }`
      );
      const link = `${baseURL}${response.data.link.substring(1)}`;
      window.open(link, '_blank');
    } catch (error) {
      toast.error('خطا در دانلود گزارش');
    }
    setLoading(false);
  };
  var _reports = reports?.docs?.map
    ? reports.docs.map((report, i) => ({
        id: report._id,
        user: report?.user ? report?.user : '',
        rowNumber: (page - 1) * itemsCountPerPage + (i + 1),
        loadingDate: report?.order
          ? moment(report?.order.loadDate).format('jMM/jDD')
          : '',
        destination: report?.order?.destination?.title || '',
        waybillType: report?.order?.waybillType
          ? _waybillType[report?.order.waybillType]
          : '',
        commissions: report?.commissions
          ? formatNumber(report?.commissions)
          : '',
        // tracingCode: report.log?.order?.tracingCode || '',
        owner:
          report?.order?.customer.firstName || report?.order?.customer.lastName
            ? report?.order?.customer.firstName +
              ' ' +
              report?.order?.customer.lastName
            : '',
        status: getStatus(report?.transaction?.verified),

        commissionDeposit: report?.transaction?.amount
          ? formatNumber(report?.transaction.amount)
          : '',
        transactionDate: report?.transaction
          ? moment(report?.transaction.createdAt).format('jMM/jDD HH:mm')
          : '',
      }))
    : [];

  return (
    <>
      {(isAdmin || hasRule('can_download_commissions_excel')) && (
        <Button
          disabled={progress}
          startIcon={<SaveIcon />}
          style={{ backgroundColor: 'green', color: 'white' }}
          onClick={handleDownloadExcel}
          fullWidth={true}
        >
          {loading ? (
            <CircularProgress color="white" size={20} />
          ) : (
            ' دانلود اکسل گزارشات'
          )}
        </Button>
      )}
      <div style={isMobile ? {} : { height: 870 }} ref={ref}>
        {progress && <LinearProgress />}
        <DataGrid
          rows={progress ? [] : _reports}
          columns={isAdmin ? columnAdmin : columns}
          localeText={localText}
          pageSize={Number(itemsCountPerPage)}
          rowCount={reports?.totalDocs || 0}
          paginationMode="server"
          onPageChange={handlePageChange}
          loading={progress}
          disableMultipleSelection
          //   onCellClick={handleSelectOrder}
          density="compact"
          onCellClick={handleSelectRow}
        />
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gridGap: 10,
          position: isMobile ? 'sticky' : '',
          bottom: isMobile ? 0 : '',
          maxHeight: isMobile ? '60px' : '',
        }}
      >
        {isAdmin && (
          <div
            style={{
              fontSize: isMobile ? 12 : 16,
              fontWeight: isMobile ? 'bolder' : '',
              padding: '6px 4px',
              border: '1px solid #1b5e20',
              background: '#a5d6a7',
            }}
          >
            مانده دریافتی:{' '}
            <strong>
              {formatNumber(
                totalCommission?.commissionsTotal -
                  totalCommission?.commissionDepositTotal || 0
              )}
            </strong>{' '}
            تومان
          </div>
        )}
        {isAdmin && (
          <div
            style={{
              fontSize: isMobile ? 12 : 16,
              fontWeight: isMobile ? 'bolder' : '',
              padding: '6px 4px',
              border: '1px solid #673ab7',
              background: '#b39ddb',
            }}
          >
            مجموع کارمزد شرکت :{' '}
            <strong>
              {formatNumber(totalCommission?.commissionsTotal || 0)}
            </strong>{' '}
            تومان
          </div>
        )}
        <div
          style={{
            fontSize: isMobile ? 12 : 16,
            fontWeight: isMobile ? 'bolder' : '',
            padding: '6px 4px',
            border: '1px solid #ef5350',
            background: '#ef9a9a',
          }}
        >
          مجموع کارمزد متعلقه :{' '}
          <strong>
            {formatNumber(totalCommission?.commissionDepositTotal || 0)}
          </strong>{' '}
          تومان
        </div>
      </div>
    </>
  );
};

export default React.memo(List);
